export const API_URL = process.env.REACT_APP_AFR_DIGITAL_ASSISTANT_API_URL;
export const CORE_URL = process.env.REACT_APP_AFR_DIGITAL_ASSISTANT_CORE_URL;
export const EMAIL_SRISHTI = process.env.REACT_APP_AFR_DIGITAL_ASSISTANT_SEND_EMAIL_FOR_MISSING_INFO_URL;
export const AUTHENTICATION_URL = (() => {
  const envAuth = process.env.REACT_APP_AFR_DIGITAL_ASSISTANT_AUTH_URL;
  const host = typeof window !== 'undefined' ? window.location.host : '';
  const DEV = 'https://afrdigitalassistant-auth.westeurope.dev.maersk.io';
  const PROD = 'https://afrdigitalassistant-auth.westeurope.prod.maersk.io';

  const isProdHost = /\.prod\.maersk\.io$/.test(host);
  const isDevHost = /\.dev\.maersk\.io$/.test(host);

  const expected = isProdHost ? PROD : isDevHost ? DEV : PROD;

  if (!envAuth) return expected;

  // Strictly validate env override: must be a well-formed URL, allowed host, and match current tier
  try {
    const u = new URL(envAuth);
    const envHost = u.hostname || '';
    const envProtocol = u.protocol || '';
    const envIsProd = /\.prod\.maersk\.io$/.test(envHost);
    const envIsDev = /\.dev\.maersk\.io$/.test(envHost);
    const envIsLocal = envHost === 'localhost' || envHost === '127.0.0.1';

    // Allowlist exact auth hosts for safety
    const allowedHosts = new Set([
      'afrdigitalassistant-auth.westeurope.dev.maersk.io',
      'afrdigitalassistant-auth.westeurope.prod.maersk.io',
      'localhost',
      '127.0.0.1'
    ]);

    // Protocol must be https for Maersk domains; http allowed for localhost
    const protocolOk = envIsLocal ? envProtocol.startsWith('http') : envProtocol === 'https:';
    const hostAllowed = allowedHosts.has(envHost);

    if (!protocolOk || !hostAllowed) {
      if (typeof window !== 'undefined') {
        // eslint-disable-next-line no-console
        console.warn('[AuthConfig] Ignoring invalid REACT_APP_AFR_DIGITAL_ASSISTANT_AUTH_URL:', envAuth);
      }
      return expected;
    }

    // Enforce tier match: prod host must not use dev auth and vice-versa
    if ((isProdHost && envIsDev) || (isDevHost && envIsProd)) {
      if (typeof window !== 'undefined') {
        // eslint-disable-next-line no-console
        console.warn('[AuthConfig] Ignoring mismatched REACT_APP_AFR_DIGITAL_ASSISTANT_AUTH_URL for host', host, '->', envAuth);
      }
      return expected;
    }

    return envAuth;
  } catch (e) {
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn('[AuthConfig] Ignoring malformed REACT_APP_AFR_DIGITAL_ASSISTANT_AUTH_URL:', envAuth);
    }
    return expected;
  }
})();
export const REDIRECT_URI = encodeURIComponent(
  process.env.REACT_APP_SSO_REDIRECT_URI || window.location.origin
);

export const CHAT_API = `${API_URL}/ws`;
// File retrieval now requires case number: /getfile/{case_number}/{filename}
export const GET_FILE_API = (caseNumber) => `${API_URL}/getfile/${encodeURIComponent(caseNumber)}`;
export const UPDATE_CASE_DETAILS_API = `${CORE_URL}/update_case_status`;
export const SEND_EMAIL_API = `${CORE_URL}/send_email`;
export const AUTH_API = `${AUTHENTICATION_URL}/login`;
export const SEND_EMAIL_FOR_MISSING_INFO_URL = `${EMAIL_SRISHTI}`;
export const GET_GLOBAL_COUNTRIES_API = `${CORE_URL}/get_global_countries`;
export const UPDATE_CASE_COUNTRY_API = `${CORE_URL}/update_case_country`;
export const CREATE_CBU_DETAIL_API = `${API_URL}/add_bankaccount_details`;
